import { Map as IMap } from 'immutable';
import { createSelector } from 'reselect';
import { STOREFRONT_FLOW } from './routingModule';
import { STOREFRONT_V2_PDP } from '../constants/constants';

export const getStorefrontRouting = state => state.get('routing', IMap());

export const getCompletedSteps = createSelector(
    getStorefrontRouting,
    routing => routing.get('completedSteps', IMap())
);

export const getStorefrontFlow = createSelector(
    getStorefrontRouting,
    steps => steps.get('flow', STOREFRONT_FLOW[0])
);

export const getIsBuyNowFlow = createSelector(
    getStorefrontFlow,
    flow => flow === STOREFRONT_FLOW[1]
);

export const getBuyFlowSelector = createSelector(
    getStorefrontRouting,
    routing => routing.get('buyFlow')
);

export const isBuyFlowPDP = createSelector(
    getBuyFlowSelector,
    buyFlow => buyFlow === STOREFRONT_V2_PDP
);
